import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import { toast } from "react-toastify";
import { useAddEcToAgentMutation } from "services/api";
import useDebounce from "hooks/useDebounce";
import { Autocomplete } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { loadContasFilter } from "actions/actions";

const useStyles = makeStyles((theme) => ({
  dialogHeader: {
    background: theme.gradient.main,
    color: "white",
  },
}));

const AddEcModal = ({
  openDialog,
  setOpenDialog,
  refetchAgentEcs,
  refetchAgent,
  agentId,
  isLoading,
  setIsLoading
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [addEcToAgent] = useAddEcToAgentMutation();
  const [accountId, setAccountId] = useState({});
  const { data: contas } = useSelector((state) => state.contas);
  const [filters, setFilters] = useState({
    like: "",
  });
  const debouncedLike = useDebounce(filters.like, 800);

  useEffect(() => {
    dispatch(loadContasFilter({ like: debouncedLike }));
  }, [dispatch, debouncedLike]);

  const handleAddEcToAgent = async () => {
    setIsLoading(true);
    try {
      await addEcToAgent({
        conta_id: accountId,
        agent_id: agentId,
      }).unwrap();
      toast.success("EC adicionado ao Representante!");
    } catch (e) {
      toast.error("Erro ao adicionar EC ao Representante!");
    } finally {
      refetchAgentEcs();
      refetchAgent();
      setOpenDialog(false);
      setIsLoading(false);
    }
  };

  return (
    <Dialog
      open={openDialog}
      onClose={() => setOpenDialog(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      style={{ zIndex: "10" }}
    >
      <Box width="600px">
        <DialogTitle className={classes.dialogHeader}>
          <Typography align="center" variant="h6">
            Adicionar EC para Representante
          </Typography>
        </DialogTitle>

        <Box display="flex" flexDirection="column" padding="6px 16px">
          <Typography>
            Escolha um EC para este Representante
          </Typography>

          <Autocomplete
            freeSolo
            fullWidth
            options={contas}
            getOptionLabel={(conta) => conta.razao_social ?? conta.nome}
            onInputChange={(_event, value, reason) => {
              if(reason !== "reset") {
                setFilters({...filters, like: value});
                setAccountId(null);
              }
            }}
            onChange={(_event, option) => {
              setAccountId(option? option.id : null);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Escolher EC" margin="normal" variant="outlined" />
            )}
          />

          <DialogActions>
            <Button
              onClick={handleAddEcToAgent}
              variant="outlined"
              color="secondary"
              disabled={accountId === null}
            >
              Adicionar
            </Button>
            <Button
              onClick={() => setOpenDialog(false)}
              color="default"
              variant="outlined"
              autoFocus
            >
              Cancelar
            </Button>
          </DialogActions>
        </Box>
      </Box>
    </Dialog>
  );
};

export default AddEcModal;
